import { createSlice, isAnyOf } from "@reduxjs/toolkit";
import { v4 as uuidv4 } from "uuid";
import {
  getSaleReturnBranch,
  getSaleReturnBranchById,
  getParticularPage,
  getNext,
  getPrevious,
  handleSearch,
  getSaleInvoiceDetail,
  createSaleReturnBranch,
  getSaleReturnBranchAdditionalChargeList,
  approveSaleReturnBranch,
  cancelSaleReturnBranch,
} from "./thunk";
import { NepaliDate } from "@zener/nepali-datepicker-react";
import { dateFormater } from "../../../../../../Utils/dateFormater";

const initialState = {
  saleReturnBranchs: [],
  edit: false,
  saleReturnBranch: null,
  count: 0,
  pageNo: 1,
  next: null,
  previous: null,
  loading: false,
  loadingCreate: false,
  loadingUpdated: false,
  loadingSaleReturnBranch: false,
  loadingNext: false,
  loadingDetails: false,
  saleInvoiceDetails: [
    {
      unique: uuidv4(),
      product: null,
      closingStock: "",
      description: "",
      actualQuantity: "",
      validateQuantity: 0,
      unit: "",
      altQuantity: "",
      altUnit: null,
      rate: "",
      amount: "",
      requiredDate: dateFormater(new NepaliDate().toADasDate()),
    },
  ],
  additionalCharges: null,
  saveAndContinue: false,
  showCreateModal: false,
  selectedSaleInvoice: null,
  selectedSaleInvoiceDetails: [],
};

export const saleReturnBranchSlice = createSlice({
  name: "saleReturnBranch",
  initialState,
  reducers: {
    setShowCreateModal: (state, action) => {
      state.showCreateModal = action.payload;
    },
    setSaveAndContinue: (state, { payload }) => {
      state.saveAndContinue = payload;
    },
    goToPage: (state, { payload }) => {
      state.pageNo = payload;
    },
    setSelectedInvoice: (state, action) => {
      state.selectedSaleInvoice = action.payload;
    },
    setSelectedInvoiceDetails: (state, action) => {
      state.selectedSaleInvoiceDetails = action.payload.map((value) => ({
        ...value,
        description: value.product?.name || "",
      }));
    },
    saleInvoiceDetailsUpdated: (state, action) => {
      state.saleInvoiceDetails = action.payload;
    },
    updatedAdditionalCharges: (state, action) => {
      state.additionalCharges = action.payload;
    },

    setSaleInvoiceDetails: (state, action) => {
      state.saleInvoiceDetails = [
        ...action.payload.map((value) => ({
          ...value,
          description: value.product?.name || "",
          actualQuantity: value.actualQuantity - value.returnQuantity,
          validateQuantity: value.actualQuantity - value.returnQuantity,
          amount: value.rate * (value.actualQuantity - value.returnQuantity),
        })),
        {
          unique: uuidv4(),
          product: null,
          closingStock: "",
          description: "",
          actualQuantity: "",
          validateQuantity: 0,
          unit: "",
          altQuantity: "",
          altUnit: null,
          rate: "",
          amount: "",
          requiredDate: dateFormater(new NepaliDate().toADasDate()),
        },
      ];
    },

    clearSelectedOrderData: (state) => {
      state.selectedSaleInvoice = null;
      state.selectedSaleInvoiceDetails = [];
    },

    clearSaleInvoiceDetails: (state) => {
      state.saleInvoiceDetails = [
        {
          unique: uuidv4(),
          product: null,
          closingStock: "",
          description: "",
          actualQuantity: "",
          validateQuantity: 0,
          unit: "",
          altQuantity: "",
          altUnit: null,
          rate: "",
          amount: "",
          requiredDate: dateFormater(new NepaliDate().toADasDate()),
        },
      ];
    },
    clearAllSaleReturnBranch: (state) => {
      state.edit = false;
      state.loading = false;
      state.loadingUpdated = false;
      state.loadingSaleReturnBranch = false;
      state.selectedSaleInvoice = null;
      state.selectedSaleInvoiceDetails = [];
      state.saleReturnBranch = null;
      state.saleInvoiceDetails = [
        {
          unique: uuidv4(),
          product: null,
          closingStock: "",
          description: "",
          actualQuantity: "",
          validateQuantity: 0,
          unit: "",
          altQuantity: "",
          altUnit: null,
          rate: "",
          amount: "",
          requiredDate: dateFormater(new NepaliDate().toADasDate()),
        },
      ];
      state.additionalCharges = null;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getSaleReturnBranchAdditionalChargeList.pending, (state) => {
      state.additionalCharges = null;
    });
    builder.addCase(getSaleReturnBranchAdditionalChargeList.fulfilled, (state, action) => {
      state.additionalCharges = action.payload.data;
    });
    builder.addCase(getSaleReturnBranchAdditionalChargeList.rejected, (state) => {
      state.additionalCharges = null;
    });

    builder.addCase(createSaleReturnBranch.pending, (state) => {
      state.loadingCreate = true;
    });
    builder.addCase(createSaleReturnBranch.fulfilled, (state, action) => {
      state.loadingCreate = false;
    });
    builder.addCase(createSaleReturnBranch.rejected, (state) => {
      state.loadingCreate = false;
    });
    // getSaleReturnBranchById
    builder.addCase(getSaleReturnBranchById.pending, (state) => {
      state.loading = true;
      state.saleReturnBranch = null;
    });
    builder.addCase(getSaleReturnBranchById.fulfilled, (state, action) => {
      state.edit = true;
      state.loading = false;
      state.saleReturnBranch = action.payload.data;
      state.saleInvoiceDetails = action.payload.data?.salesOrderReturnDetails.map((value) => {
        return { ...value, unique: uuidv4() };
      });
    });
    builder.addCase(getSaleReturnBranchById.rejected, (state) => {
      state.edit = false;
      state.loading = false;
      state.saleReturnBranch = null;
    });
    builder.addMatcher(
      isAnyOf(
        (createSaleReturnBranch.pending, approveSaleReturnBranch.pending, cancelSaleReturnBranch.pending),
        (state) => {
          state.loadingSaleReturnBranch = true;
        }
      )
    );
    builder.addMatcher(
      isAnyOf(
        (createSaleReturnBranch.fulfilled, approveSaleReturnBranch.fulfilled, cancelSaleReturnBranch.fulfilled),
        (state) => {
          state.loadingSaleReturnBranch = true;
        }
      )
    );
    builder.addMatcher(
      isAnyOf(
        (createSaleReturnBranch.rejected, approveSaleReturnBranch.rejected, cancelSaleReturnBranch.rejected),
        (state) => {
          state.loadingSaleReturnBranch = true;
        }
      )
    );
    builder.addMatcher(
      isAnyOf(
        getSaleReturnBranch.pending,
        getParticularPage.pending,
        getPrevious.pending,
        getNext.pending,
        handleSearch.pending
      ),
      (state) => {
        state.loadingSaleReturnBranch = true;
      }
    );

    builder.addMatcher(
      isAnyOf(
        getSaleReturnBranch.fulfilled,
        getParticularPage.fulfilled,
        getPrevious.fulfilled,
        getNext.fulfilled,
        handleSearch.fulfilled
      ),
      (state, action) => {
        state.loadingSaleReturnBranch = false;
        state.saleReturnBranchs = action.payload.data;
        state.count = action.payload.totalCount;

        state.previous = action.payload.previous;
        state.next = action.payload.next;
      }
    );
    builder.addMatcher(
      isAnyOf(
        getSaleReturnBranch.rejected,
        getParticularPage.rejected,
        getPrevious.rejected,
        getNext.rejected,
        handleSearch.rejected
      ),
      (state) => {
        state.loadingSaleReturnBranch = false;
      }
    );
  },
});

export const {
  setShowCreateModal,
  setSaveAndContinue,
  goToPage,
  setSelectedInvoice,
  setSelectedInvoiceDetails,
  saleInvoiceDetailsUpdated,
  setSaleInvoiceDetails,
  updatedAdditionalCharges,
  clearSelectedOrderData,
  clearSaleInvoiceDetails,
  clearAllSaleReturnBranch,
} = saleReturnBranchSlice.actions;

export default saleReturnBranchSlice.reducer;
